import { Controller } from "@hotwired/stimulus";
import * as AutoKana from 'vanilla-autokana';

export default class extends Controller {
  connect() {
    const fields = this.element.querySelectorAll('.kana_conversion');
    fields.forEach(field => {
      const elementId = field.getAttribute('id');
      AutoKana.bind(elementId, `${elementId}Kana`, { katakana: true });
    });
  }
}
